export default {
    title: "Il tuo responsabile approvante è {email}"
}